module.exports = __webpack_public_path__ + "static/media/wind.3f30db80.jpg";